import VALIDATOR from "./validator";
export default {
  /**
   * 登录校验
   * */
  // 账号密码登陆
  rulesAccountAndPwd: {
    passWord: [
      { required: true, message: "请输入登录密码", trigger: ["blur", "change"] }
    ],
    loginName: [
      { required: true, message: "请输入登录账号", trigger: ["blur", "change"] }
    ],
    smsCode: [
      {
        required: true,
        validator: VALIDATOR.vdtCheckNum,
        trigger: ["blur", "change"]
      }
    ]
  },

  // 找回密码
  rulesFindPassword: {
    smsCode: [
      {
        required: true,
        validator: VALIDATOR.vdtCheckNum,
        trigger: ["blur", "change"]
      }
    ]
  },

  // 验证码免密登录
  rulesCodeLogin: {
    mobile: [
      {
        required: true,
        message: "请输入登录手机号",
        trigger: ["blur", "change"]
      }
    ],
    smsCode: [
      {
        required: true,
        validator: VALIDATOR.vdtCheckNum,
        trigger: ["blur", "change"]
      }
    ]
  },

  /**
   * 修改密码校验
   * */
  oldPwd: [
    { required: true, message: "请输入旧密码", trigger: ["blur", "change"] }
  ],
  //验证密码
  newPwd: [{ validator: VALIDATOR.validatePass, trigger: ["blur", "change"] }],
  //验证确认密码
  confirmPwd: [
    { validator: VALIDATOR.validatePass2, trigger: ["blur", "change"] }
  ],

  /**
   * 新增批次校验
   * */
  //验证商户名称是否选中
  AddcooperatorId: [
    {
      type: "array",
      required: true,
      validator: VALIDATOR.checkNull,
      trigger: ["blur", "change"]
    }
  ],
  // 验证批次名称
  batchName: [
    {
      required: true,
      validator: VALIDATOR.checkNull,
      trigger: ["blur", "change"]
    }
  ],
  //批次说明
  batchRemark: [
    {
      required: true,
      validator: VALIDATOR.checkNull,
      trigger: ["blur", "change"]
    }
  ],
  //关联任务
  positionId: [
    {
      required: true,
      validator: VALIDATOR.checkNull,
      trigger: ["blur", "change"]
    }
  ],
  //开票类目
  invoiceCategoryTemp: [
    { required: true, validator: VALIDATOR.checkNull, trigger: ["blur"] }
  ],
  // 任务描述
  workContent: [
    { required: true, validator: VALIDATOR.checkNull, trigger: ["blur"] }
  ],
  // 服务费说明
  wageStatement: [
    { required: true, validator: VALIDATOR.checkNull, trigger: ["blur"] }
  ],
  // 服务时间
  workTime: [
    { required: true, validator: VALIDATOR.checkNull, trigger: ["blur"] }
  ],

  /**
   * 修改补发批次验证--新增批次
   *
   * */
  mod_AddcooperatorId: [
    {
      type: "array",
      required: true,
      validator: VALIDATOR.checkNull,
      trigger: ["blur", "change"]
    }
  ],

  reissueBatchName: [
    {
      type: "string",
      required: true,
      validator: VALIDATOR.checkNull,
      trigger: ["blur", "change"]
    }
  ],
  //批次说明
  reissueBatchRemark: [
    {
      type: "string",
      required: true,
      validator: VALIDATOR.checkNull,
      trigger: ["blur", "change"]
    }
  ],

  /**
   * 修改批次校验
   * */
  //收款人姓名
  gatheringWorkName: [
    {
      required: true,
      validator: VALIDATOR.gatheringWorkName,
      trigger: ["blur", "change"]
    }
  ],
  //证件类型
  idType: [
    {
      required: true,
      validator: VALIDATOR.checkNull,
      trigger: ["blur", "change"]
    }
  ],
  //证件号
  idNumber: [
    {
      required: true,
      validator: VALIDATOR.validateCard,
      trigger: ["blur", "change"]
    }
  ],
  //手机号码
  phoneNo: [
    {
      required: true,
      validator: VALIDATOR.validatePhone,
      trigger: ["blur", "change"]
    }
  ],
  //收款账号
  workerAccount: [
    {
      required: true,
      validator: VALIDATOR.checkNull,
      trigger: ["blur", "change"]
    }
  ],

  /**
   * 添加子账号校验
   * */
  //验证登录账号
  loginName: [
    {
      required: true,
      validator: VALIDATOR.validateAddEmailLogin,
      trigger: ["blur", "change"]
    }
  ],
  //邮箱验证
  email: [
    {
      required: true,
      validator: VALIDATOR.validateEmail,
      trigger: ["blur", "change"]
    }
  ],
  //验证用户名称
  userName: [
    {
      required: true,
      message: " ",
      trigger: ["blur", "change"]
    }
  ],
  //验证手机号并验证是否已被使用
  phoneNoXhr: [
    {
      required: true,
      validator: VALIDATOR.validatePhone,
      trigger: ["blur", "change"]
    }
  ],
  //验证密码
  loginPwd: [
    { validator: VALIDATOR.validatePass, trigger: ["blur", "change"] }
  ],
  //验证确认密码
  confirmPwd: [
    { validator: VALIDATOR.validatePass2, trigger: ["blur", "change"] }
  ],

  /**
   * 用户管理-编辑用户信息
   * */
  //用户姓名
  workerName: [
    {
      required: true,
      validator: VALIDATOR.ChineseEnglishName,
      trigger: ["blur"]
    }
  ],
  //用户编号
  workerCode: [
    {
      required: true,
      validator: VALIDATOR.ChineseEnglishCode,
      trigger: ["blur"]
    }
  ],
  //手机号
  workerMobile: [
    { required: true, validator: VALIDATOR.validatePhone, trigger: ["blur"] }
  ],

  /**
   * 接口对接
   * */
  // 验证码
  phoneVerifyCode: [
    {
      required: true,
      validator: VALIDATOR.verifyCodeCheck,
      trigger: ["blur", "change"]
    }
  ],

  //判断客户名称
  nameComster: [
    {
      required: true,
      validator: VALIDATOR.checkNull,
      trigger: ["blur", "change"]
    }
  ],

  /**
   * 批次数据准备-收款渠道
   * */
  receiptChannel: [
    {
      required: true,
      validator: VALIDATOR.checkNull,
      trigger: ["blur", "change"]
    }
  ],

  /**
   * 财务中心-充值记录
   * */
  rechargeRecordAdd: {
    coperatorName: [
      {
        required: true,
        validator: VALIDATOR.checkNull,
        trigger: ["blur", "change"]
      }
    ],
    aggregateSum: [
      {
        required: true,
        validator: VALIDATOR.checkNull,
        trigger: ["blur", "change"]
      }
    ],
    telePhone: [
      {
        required: true,
        validator: VALIDATOR.validatePhone,
        trigger: ["blur", "change"]
      }
    ],
    tempLocation: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["blur"] }
    ],
    // recipientsLocation:[{  required: true, validator: VALIDATOR.checkNull, trigger: ["blur"] }],
    recipientsName: [
      {
        required: true,
        validator: VALIDATOR.checkNull,
        trigger: ["blur", "change"]
      }
    ],
    phoneNo: [
      {
        required: true,
        validator: VALIDATOR.checkNull,
        trigger: ["blur", "change"]
      }
    ],
    invoiceKind: [
      {
        required: true,
        validator: VALIDATOR.checkNull,
        trigger: ["blur", "change"]
      }
    ],
    invoiceMoney: [{ required: true }],
    invoiceVariety: [
      {
        required: true,
        validator: VALIDATOR.checkNull,
        trigger: ["blur", "change"]
      }
    ]
  },

  /**
   * 财务中心 - 发票申请校验
   * */
  invoiceApplyRulesVdt: {
    phoneNo: [
      { required: true, validator: VALIDATOR.checkNull, trigger: "change" }
    ],
    recipientsName: [
      { required: true, validator: VALIDATOR.checkNull, trigger: "change" }
    ],
    tempLocation: [
      { required: true, validator: VALIDATOR.checkNull, trigger: "change" }
    ],
    invoiceKind: [
      { required: true, validator: VALIDATOR.checkNull, trigger: "change" }
    ]
  },

  // 新建任务
  createTaskRulesVdt: {
    taskType: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["blur"] }
    ],
    taskName: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["blur"] }
    ],
    taskIntroduction: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["blur"] }
    ],
    min: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["blur"] }
    ],
    settlementCycle: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["blur"] }
    ],
    emergencyLevel: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["blur"] }
    ],
    workPlace: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["blur"] }
    ],
    workTimeTemp: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["blur"] }
    ]
  },

  // 编辑任务
  editTaskRulesVdt: {
    taskName: [
      {
        required: true,
        validator: VALIDATOR.checkNull,
        trigger: ["blur", "change"]
      }
    ],
    taskIntroduction: [
      {
        required: true,
        validator: VALIDATOR.checkNull,
        trigger: ["blur", "change"]
      }
    ],
    min: [
      {
        required: true,
        validator: VALIDATOR.checkNull,
        trigger: ["blur", "change"]
      }
    ],
    settlementCycle: [
      {
        required: true,
        validator: VALIDATOR.checkNull,
        trigger: ["blur", "change"]
      }
    ]
  },

  //任务管理 - 发布任务
  publishTaskRulesVdt: {
    positionName: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["blur"] }
    ],
    positionTypeName: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["blur"] }
    ],
    settlementCycle: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["change"] }
    ],
    unit: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["change"] }
    ],
    gender: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["change"] }
    ],
    workAddress: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["change"] }
    ],
    // positionDesc:[{required: true, validator: VALIDATOR.checkNull, trigger: ["blur"] }],
    positionWorkContent: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["blur"] }
    ],
    positionWageStatement: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["blur"] }
    ],
    positionWorkTime: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["blur"] }
    ],
    // positionOtherBenefits:[{required: true, validator: VALIDATOR.checkNull, trigger: ["blur"] }],
    monthAge: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["change"] }
    ],
    education: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["change"] }
    ],
    monthAmount: [{ required: true, message: " ", trigger: ["blur"] }],
    requirementQualificationType: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["change"] }
    ],
    benefits: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["change"] }
    ],
    positionTag: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["change"] }
    ],
    shopName: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["blur"] }
    ],
    shopContact: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["blur"] }
    ],
    shopContactMobile: [
      { required: true, validator: VALIDATOR.validatePhone, trigger: ["blur"] }
    ],
    workLocation: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["blur"] }
    ],
    categoryList: [{ required: true, message: " ", trigger: "blur" }],
    secondCategoryId: [{ required: true, message: " ", trigger: "change" }],
    workType: [{ required: true, message: " ", trigger: "change" }],
    recruitmentType: [{ required: true, message: " ", trigger: "change" }],
    deliveryType: [{ required: true, message: " ", trigger: "change" }]
  },

  //新网银行批次校验
  xwBankBatchRulesVdt: {
    cooperatorId: [
      { required: true, validator: VALIDATOR.checkNull, trigger: "change" }
    ],
    batchName: [
      { required: true, validator: VALIDATOR.checkNull, trigger: "change" }
    ],
    invoiceCategoryTemp: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["blur"] }
    ],
    invoiceContent: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["blur"] }
    ],
    positionId: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["change"] }
    ],
    workContent: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["blur"] }
    ],
    wageStatement: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["blur"] }
    ],
    workTime: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["blur"] }
    ]
  },

  // 开通电子台账 - 第一步
  addElectAccount: {
    employerEnterpriseUnifiedCode: [
      {
        required: true,
        validator: VALIDATOR.checkNull,
        trigger: ["blur", "change"]
      }
    ],
    employerEnterpriseLegalName: [
      {
        required: true,
        validator: VALIDATOR.checkNull,
        trigger: ["blur", "change"]
      }
    ],
    employerEnterpriseContactIdCardNo: [
      {
        required: true,
        validator: VALIDATOR.validateCard,
        trigger: ["blur", "change"]
      }
    ],
    employerEnterpriseContactName: [
      {
        required: true,
        validator: VALIDATOR.checkNull,
        trigger: ["blur", "change"]
      }
    ],
    employerEnterpriseContactPhone: [
      {
        required: true,
        validator: VALIDATOR.validatePhone,
        trigger: ["blur", "change"]
      }
    ],
    messageCaptcha: [
      {
        required: true,
        validator: VALIDATOR.checkNull,
        trigger: ["blur", "change"]
      }
    ],
    tradePassword: [
      { required: true, validator: VALIDATOR.checkNull, trigger: "change" }
    ]
  },

  // 电子台账开通确认 - 第二步
  electAccountConfirm: {
    messageCaptcha: [
      {
        required: true,
        validator: VALIDATOR.checkNull,
        trigger: ["blur", "change"]
      }
    ]
  },

  //绑定付款账户
  addPayAccount: {
    payerAccountNo: [
      { required: true, validator: VALIDATOR.vdtCheckNum, trigger: ["blur"] }
    ],
    payerBankName: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["blur"] }
    ]
  },

  //余额管理手动上帐
  paramsRecordRules: {
    paymentAccount: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["blur"] }
    ],
    paymentBank: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["blur"] }
    ],
    paymentAmount: [
      { required: true, validator: VALIDATOR.vdtCheckPrice, trigger: ["blur"] }
    ],
    // txId: [{required: true, validator: VALIDATOR.vdtCheckNum, trigger: ["blur"] }],
    paymentRemark: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["blur"] }
    ]
  },

  // 更换银行卡号
  changeBankNo: {
    bankCardNo: [
      {
        required: true,
        validator: VALIDATOR.checkNull,
        trigger: ["blur", "change"]
      }
    ],
    receiptChannel: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["change"] }
    ]
  },

  // 编辑用工单信息
  editEmployeeInfo: {
    salaryAmount: [
      {
        required: true,
        validator: VALIDATOR.vdtCheckPrice,
        trigger: ["blur", "change"]
      }
    ],
    awardAmount: [
      {
        required: true,
        validator: VALIDATOR.vdtCheckPrice,
        trigger: ["blur", "change"]
      }
    ],
    workload: [
      {
        required: true,
        validator: VALIDATOR.vdtCheckOneDecimal,
        trigger: ["blur", "change"]
      }
    ]
  },

  rulesVerifyCode: {
    code: [
      {
        required: true,
        validator: VALIDATOR.checkNull,
        trigger: ["blur", "change"]
      }
    ]
  },

  // 安心签-发送验证码
  rulesOpenSendSms: {
    creditNo: [
      {
        required: true,
        message: "请输入统一社会信用代码",
        trigger: ["blur", "change"]
      }
    ],
    contactMobile: [
      {
        required: true,
        message: "请联系运营人员维护发票信息",
        trigger: ["blur", "change"]
      }
    ],
    userName: [
      {
        required: true,
        message: "请输入企业联系人",
        trigger: ["blur", "change"]
      }
    ],
    idNumber: [
      {
        required: true,
        validator: VALIDATOR.validateCard,
        trigger: ["blur", "change"]
      }
    ],
    email: [
      {
        required: true,
        validator: VALIDATOR.validateEmail,
        trigger: ["blur", "change"]
      }
    ],
    phoneNo: [
      {
        required: true,
        validator: VALIDATOR.validatePhone,
        trigger: ["blur", "change"]
      }
    ]
  },
  // 安心签-开户
  rulesOpenPeaceOfMind: {
    code: [
      {
        required: true,
        validator: VALIDATOR.checkNull,
        trigger: ["blur", "change"]
      }
    ]
  },
  // 批量提交结算单---验证码
  batchMultiSalary: {
    captcha: [
      {
        required: true,
        validator: VALIDATOR.checkNull,
        trigger: ["blur"]
      }
    ]
  },

  // 上传结算单
  uploadSettlement: {
    batchName: [
      {
        required: true,
        validator: VALIDATOR.checkNull,
        trigger: ["blur"]
      }
    ],
    receiptChannel: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["blur"] }
    ],
    positionId: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["blur"] }
    ]
  },

  // 补传结算单
  retransmitSettlement: {
    batchName: [
      {
        required: true,
        validator: VALIDATOR.checkNull,
        trigger: ["blur"]
      }
    ],
    receiptChannel: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["blur"] }
    ],
    positionId: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["blur"] }
    ],
    batchCreateDate: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["blur"] }
    ]
  },

  // 签署
  signGetCode: {
    creditNo: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["blur"] }
    ],
    contactName: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["blur"] }
    ],
    contactMobile: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["blur"] }
    ],
    contactEmail: [
      { required: true, validator: VALIDATOR.validateEmail, trigger: ["blur"] }
    ],
    contactPhone: [
      { required: true, validator: VALIDATOR.validatePhone, trigger: ["blur"] }
    ],
    contactIdNumber: [
      { required: true, validator: VALIDATOR.validateCard, trigger: ["blur"] }
    ]
  },

  // oem配置
  oemConfigVdt: {
    clientName: [{ required: true, message: " ", trigger: "blur" }],
    webDomain: [{ required: true, message: " ", trigger: "blur" }],
    h5Domain: [{ required: true, message: " ", trigger: "blur" }],
    smsSignature: [{ required: true, message: " ", trigger: "blur" }],
    copyrightState: [{ required: true, message: " ", trigger: "blur" }],
    webHomeLogo: [{ required: true, message: " ", trigger: "blur" }],
    webNavigationLogo: [{ required: true, message: " ", trigger: "blur" }],
    h5HomeLogo: [{ required: true, message: " ", trigger: "blur" }]
  },

  //用工结算单编辑人员（非共管） && 用工结算单编辑人员（共管）
  rulesEditStaff: {
    workerName: [
      { required: true, validator: VALIDATOR.checkNull, trigger: "change" }
    ],
    idType: [
      { required: true, validator: VALIDATOR.checkNull, trigger: "change" }
    ],
    idNumber: [
      { required: true, validator: VALIDATOR.checkNull, trigger: "change" }
    ],
    phoneNo: [
      { required: true, validator: VALIDATOR.validatePhone, trigger: "change" }
    ]
  },

  //切换下发公司校验
  changeDisCoorVdt: {
    cooperatorId: [
      { required: true, validator: VALIDATOR.checkNull, trigger: ["change"] }
    ]
  },

  // 开票申请 - 开票信息
  rulesBillingApply: {
    invoiceKind: [
      { required: true, message: " ", trigger: ["blur", "change"] }
    ],
    invoiceMoney: [
      {
        required: true,
        validator: VALIDATOR.vdtCheckPrice,
        trigger: ["blur", "change"]
      }
    ],
    invoiceVariety: [
      { required: true, message: " ", trigger: ["blur", "change"] }
    ]
  },

  // 开票记录 - 开票信息管理
  rulesBillingInfo: {
    openingBank: [{ required: true, message: " ", trigger: ["blur"] }],
    openingAccount: [{ required: true, message: " ", trigger: ["blur"] }],
    taxPhoneNo: [{ required: true, message: " ", trigger: ["blur"] }],
    companyLocation: [{ required: true, message: " ", trigger: ["blur"] }],
    recipientsName: [{ required: true, message: " ", trigger: ["blur"] }],
    phoneNo: [
      { required: true, validator: VALIDATOR.validatePhone, trigger: ["blur"] }
    ],
    recipientsLocationTemp: [
      { required: true, message: " ", trigger: ["blur"] }
    ]
  },

  // 开票记录 - 购买方信息，开票信息
  rulesInvoicingRecord: {
    recipientsName: [
      { required: true, message: " ", trigger: ["blur", "change"] }
    ],
    phoneNo: [
      {
        required: true,
        validator: VALIDATOR.validatePhone,
        trigger: ["blur", "change"]
      }
    ],
    recipientsLocationTemp: [
      { required: true, message: " ", trigger: ["blur", "change"] }
    ],
    invoiceKind: [{ required: true, message: " ", trigger: ["blur"] }],
    invoiceMoney: [
      {
        required: true,
        validator: VALIDATOR.vdtCheckPriceToThousands,
        trigger: ["blur", "change"]
      }
    ],
    invoiceVariety: [{ required: true, message: " ", trigger: ["blur"] }],
    positionEntities: [
      { required: true, message: " ", trigger: ["blur", "change"] }
    ]
  },

  // 验证码免密登录
  smsInsuranceZb: {
    smsCode: [
      { required: true, message: "请输入验证码", trigger: ["blur", "change"] }
    ]
  },

  //合规中心 - 合作评估表
  cooperaEvaluaForm: {
    industryCategory: [{ required: true, message: " ", trigger: ["blur"] }],
    businessCoverageProvinces: [
      { required: true, message: " ", trigger: ["blur", "change"] }
    ],
    companyEmployees: [
      { required: true, message: " ", trigger: ["blur", "change"] }
    ],
    incomeScaleBegin: [{ required: true, message: " ", trigger: ["blur"] }],
    incomeScaleEnd: [{ required: true, message: " ", trigger: ["blur"] }],
    freelanceJobs: [{ required: true, message: " ", trigger: ["blur"] }],
    sceneDesc: [{ required: true, message: " ", trigger: ["blur"] }],
    invoiceContent: [{ required: true, message: " ", trigger: ["blur"] }],
    workerPlace: [
      { required: true, message: " ", trigger: ["blur", "change"] }
    ],
    monthIncomeRange: [{ required: true, message: " ", trigger: ["blur"] }],
    numberOfFreelancers: [
      { required: true, message: " ", trigger: ["blur", "change"] }
    ],
    totalMonthlyPayment: [
      { required: true, message: " ", trigger: ["blur", "change"] }
    ],
    expenseReleaseCycle: [
      { required: true, message: " ", trigger: ["blur", "change"] }
    ],
    proofOfAuthenticity: [
      { required: true, message: " ", trigger: ["blur", "change"] }
    ],
    paymentAccount: [{ required: true, message: " ", trigger: ["blur"] }]
  },

  rulesAddRefereeForm: {
    recommenderName: [{ required: true, message: " ", trigger: ["blur"] }],
    recommenderMobile: [{ required: true, message: " ", trigger: ["blur"] }]
  },

  // 线上合同签署
  onlineContractSignForm: {
    // 发票信息
    cooperatorName: [{ required: true, message: " ", trigger: ["blur"] }],
    uscCode: [{ required: true, message: " ", trigger: ["blur"] }],
    invoicePhoneNo: [{ required: true, message: " ", trigger: ["blur"] }],
    invoiceAddress: [{ required: true, message: " ", trigger: ["blur"] }],
    invoiceBankBranchName: [
      { required: true, message: " ", trigger: ["blur"] }
    ],
    invoiceBankAccountNo: [{ required: true, message: " ", trigger: ["blur"] }],
    // 法人信息
    legalPersonName: [{ required: true, message: " ", trigger: ["blur"] }],
    legalPersonIdCard: [
      { required: true, validator: VALIDATOR.validateCard, trigger: ["blur"] }
    ],

    // 经办人信息
    operatorName: [{ required: true, message: " ", trigger: ["blur"] }],
    operatorAddress: [{ required: true, message: " ", trigger: ["blur"] }],
    operatorIdCard: [
      { required: true, validator: VALIDATOR.validateCard, trigger: ["blur"] }
    ],
    operatorMobile: [
      { required: true, validator: VALIDATOR.validatePhone, trigger: ["blur"] }
    ],
    operatorEmail: [
      { required: true, validator: VALIDATOR.validateEmail, trigger: ["blur"] }
    ],

    // 更新支付验证信息
    paymentBankAccountNo: [{ required: true, message: " ", trigger: ["blur"] }],
    paymentBankBranchName: [
      { required: true, message: " ", trigger: ["blur"] }
    ],
    paymentBankBranchNo: [
      { required: true, validator: VALIDATOR.vdtCheckNum, trigger: ["blur"] }
    ],
    paymentAmount: [
      { required: true, validator: VALIDATOR.vdtCheckPrice, trigger: ["blur"] }
    ],

    value: [{ required: true, message: " ", trigger: ["blur"] }],
    value1: [
      { required: true, validator: VALIDATOR.validatePhone, trigger: ["blur"] }
    ]
  },

  // 切换门店
  switchStores: {
    shopId: [{ required: true, message: " ", trigger: ["blur", "change"] }]
  },

  // 自由职业者列表编辑备注
  professionalListEdit: {
    notes: [{ required: true, message: " ", trigger: "blur" }]
  }
};

export const rulePersonnelSettlementExport = {
  receiptChannel: [{ required: true, message: "  ", trigger: "change" }],
  workerIdList: [{ required: true, message: "  ", trigger: "blur" }]
};

// 主账号信息变更
export const ruleInformationForm = {
  code: [
    { required: true, validator: VALIDATOR.verifyCodeCheck, trigger: "change" }
  ],
  loginName: [{ required: true, message: "  ", trigger: "blur" }],
  userName: [{ required: true, message: "  ", trigger: "blur" }],
  idNumber: [
    { required: true, validator: VALIDATOR.validateCard, trigger: "blur" }
  ],
  phoneNo: [
    { required: true, validator: VALIDATOR.validatePhone, trigger: "blur" }
  ],
  email: [
    { required: true, validator: VALIDATOR.validateEmail, trigger: "blur" }
  ]
};

// 导出报税文件
export const ruleTaxReceipt = {
  dateTemp: [{ required: true, message: " ", trigger: ["blur", "change"] }]
};



// WEBPACK FOOTER //
// ./src/FormVerification/index.js